import React from 'react';

import { defineGetters } from '../../../../support/defineGetters';
import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  ModalForm,
  Radio,
  RadioGroup,
  VStack,
} from '../../../../core-ui';
import {
  InvoiceTotalModifier,
  InvoiceTotalModifierRuntype,
} from '../../../../runtypes/RedemptionRuntype';

type RedemptionsTableFooterProps = {
  name: string;
  isSaving: boolean;
  invoiceTotalModifier: InvoiceTotalModifier;
  addAbsValueToSalesTotal: boolean;
  isModalOpen: boolean;
  onClick: () => void;
  onClose: () => void;
  onNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onInvoiceTotalModifierChange: (value: InvoiceTotalModifier) => void;
  onAddAbsValueToSalesTotalChange: (value: boolean) => void;
  onSubmit: () => void;
};

export function RedemptionsTableFooter(props: RedemptionsTableFooterProps) {
  const {
    name,
    isSaving,
    invoiceTotalModifier,
    addAbsValueToSalesTotal,
    isModalOpen,
    onClick,
    onClose,
    onNameChange,
    onInvoiceTotalModifierChange,
    onAddAbsValueToSalesTotalChange,
    onSubmit,
  } = props;

  const coerceIntoModifier = (input: string): InvoiceTotalModifier => {
    const newValue = InvoiceTotalModifierRuntype.guard(input) ? input : 'none';
    return newValue;
  };

  const invoiceModifiersToLabel = defineGetters<InvoiceTotalModifier>({
    add: () => t('Add'),
    none: () => t('None'),
    subtract: () => t('Subtract'),
  });
  const invoiceModifierOptions = Object.keys(invoiceModifiersToLabel);

  const optionsToLabel = defineGetters<'true' | 'false'>({
    true: () => t('Yes'),
    false: () => t('No'),
  });
  const options = Object.keys(optionsToLabel);

  return (
    <>
      <Button isLoading={isSaving} isFullWidth onClick={onClick}>
        {t('Add redemption')}
      </Button>
      <ModalForm
        title={t('Add redemption')}
        isOpen={isModalOpen}
        submitButtonText={t('Add redemption')}
        onClose={onClose}
        onSubmit={onSubmit}
      >
        <VStack align="stretch">
          <FormControl>
            <FormLabel>{t('Redemption Name')}</FormLabel>
            <Input autoFocus={true} onChange={onNameChange} value={name} />
          </FormControl>
          <FormControl>
            <FormLabel>{t('Modify invoice total')}</FormLabel>
            <RadioGroup
              onChange={(value) => {
                const newValue = coerceIntoModifier(value);
                onInvoiceTotalModifierChange(newValue);
              }}
              value={invoiceTotalModifier}
            >
              <HStack spacing={5}>
                {invoiceModifierOptions.map((key) => (
                  <Radio key={key} value={key}>
                    {invoiceModifiersToLabel[key]}
                  </Radio>
                ))}
              </HStack>
            </RadioGroup>
          </FormControl>
          <FormControl>
            <FormLabel>{t('Add value to sales total')}</FormLabel>
            <RadioGroup
              onChange={(value) => {
                onAddAbsValueToSalesTotalChange(value === 'true');
              }}
              value={String(addAbsValueToSalesTotal)}
            >
              <HStack spacing={5}>
                {options.map((key) => (
                  <Radio key={key} value={key}>
                    {optionsToLabel[key]}
                  </Radio>
                ))}
              </HStack>
            </RadioGroup>
          </FormControl>
        </VStack>
      </ModalForm>
    </>
  );
}
